// This is a type-only import and this package depends on @types/react
// eslint-disable-next-line import/no-extraneous-dependencies

// Heads up! Keep in sync with FocusZone.types.ts

export var FocusZoneTabbableElements;
(function (FocusZoneTabbableElements) {
  FocusZoneTabbableElements[FocusZoneTabbableElements["none"] = 0] = "none";
  FocusZoneTabbableElements[FocusZoneTabbableElements["all"] = 1] = "all";
  FocusZoneTabbableElements[FocusZoneTabbableElements["inputOnly"] = 2] = "inputOnly";
})(FocusZoneTabbableElements || (FocusZoneTabbableElements = {}));
export var FocusZoneDirection;
(function (FocusZoneDirection) {
  FocusZoneDirection[FocusZoneDirection["vertical"] = 0] = "vertical";
  FocusZoneDirection[FocusZoneDirection["horizontal"] = 1] = "horizontal";
  FocusZoneDirection[FocusZoneDirection["bidirectional"] = 2] = "bidirectional";
  FocusZoneDirection[FocusZoneDirection["bidirectionalDomOrder"] = 3] = "bidirectionalDomOrder";
})(FocusZoneDirection || (FocusZoneDirection = {}));
//# sourceMappingURL=types.js.map
